import segment from 'src/js/modules/analytics/segment';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';

const trackBlockSettingsDialogDisplayed = ({ tabId, blockId, blockVariationId, triggerId }) => {
  if (!tabId || !blockId) return;

  const {
    trackers: { trackEvent },
    constants,
  } = segment;

  trackEvent(constants.events.BLOCK_SETTINGS_DIALOG_DISPLAYED, {
    dialogId: dialogTypes.BLOCK_SETTINGS,
    tabId,
    blockId,
    blockVariationId,
    triggerId,
  });
};

export default trackBlockSettingsDialogDisplayed;
